module.exports = __webpack_public_path__ + "img/533B33_AF9998_866965_9C7E7B-256px.cffc4ce9.png";